import { type UseFormReturn } from 'react-hook-form';
import * as z from 'zod';

import { AttachmentSchema } from '#packages/data-collection/models/common/attachment';
import { AuditWaterFixtureFormEntrySchema } from '#packages/data-collection/models/audit-water-fixture-form';

const FormAttachmentSchema = AttachmentSchema.extend({
  file: z.instanceof(File),
});

export const EditAuditFormWaterFixtureEntryDataSchema =
  AuditWaterFixtureFormEntrySchema.omit({
    attachments: true,
  }).extend({
    attachments: z.array(FormAttachmentSchema).optional(),
  });

export type EditAuditFormWaterFixtureEntryData = Omit<
  z.infer<typeof EditAuditFormWaterFixtureEntryDataSchema>,
  'quantity' | 'usageRate'
> & {
  quantity?: string;
  usageRate?: string;
};

export type EditAuditFormWaterFixtureEntry =
  UseFormReturn<EditAuditFormWaterFixtureEntryData>;
